import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const ClockIcon = (p: IconProps) => <Icon {...p}><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></Icon>
